var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F57C00",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.833,
    fillOpacity: 0.15,
    stroke: "#F57C00",
    strokeWidth: 1.167
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M6.417 4.224v3.219c0 .4.26.724.583.724.322 0 .583-.324.583-.724V4.224c0-.4-.26-.724-.583-.724-.322 0-.583.324-.583.724zm0 5.693a.582.582 0 1 0 1.166 0 .583.583 0 1 0-1.166 0z"
  }))));
};
export default SvgAlert;